import axios from "axios";
import { API_END_POINTS } from "../../API_END_POINTS";

const REVIEW_URL = `${process.env.REACT_APP_API_URL}${API_END_POINTS.productReview}`;

export const reviewServices = async (
  lastId = "",
  limit = 10,
  productId,
  api_token
) => {
  try {
    const response = await axios.post(
      REVIEW_URL,
      {
        last_id: lastId,
        limit: limit,
        product_id: productId,
      },
      {
        headers: {
          Authorization: `Bearer ${api_token}`,
          "Content-Type": "application/json",
        },
      }
    );

    return response.data; // Ensure correct data extraction
  } catch (error) {
    throw new Error(
      error.response?.data?.message ||
        "An error occurred while fetching product reviews."
    );
  }
};
